import React from 'react';
import { msg } from "src/app/msg";
import { queryStringModifier } from "nood-comp/src/util/converters/converters";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import * as stylex from "@stylexjs/stylex";
import Table from "nood-comp/src/comp/data/table/Table";
import { RandomStringGenerator } from "nood-comp/src/util/rand/RandomStringGenerator";
export default function Systems(props) {
  document.title = msg.title("Systems");
  console.log("Systems.tsx hehehe ", RandomStringGenerator.alphanum(5));
  return /*#__PURE__*/React.createElement(Table, {
    key: "table-system",
    data_source: "/systems",
    rowPadding: 5,
    paging: {
      sorters: [{
        property: 'created_dt',
        isAsc: false
      }]
    },
    cols: [{
      label: "Short Name",
      property: "short_name",
      icon: "tag",
      width: 150,
      filterType: "text",
      to: function to(obj, idx) {
        return queryStringModifier({
          queryString: document.location.search,
          modifiers: {
            "do": "view",
            id: obj.id
          }
        });
      },
      filterTextfieldWidth: 120
    }, {
      label: "Name",
      property: "name",
      icon: "menu",
      filterType: "text"
    }, {
      label: "",
      property: "created_dt",
      width: 70,
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          datetime: obj.created_dt
        });
      }
    }]
  });
}

// @ts-ignore